import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import BTable from "react-bootstrap/Table";
import { Spinner, Pagination } from "react-bootstrap";

import { useTable, useSortBy, usePagination, Column } from "react-table";
import { useSticky } from "react-table-sticky";
import BottomBlinker from "../../components/BottomBlinker";

import classNames from 'classnames/bind';
import style from '../../components/DataTable/index.module.css';
const cx = classNames.bind(style);
// import { UseTableInstanceProps } from "react-table";

type onHeaderClickFunc = (name: string, asc: boolean,) => void;
interface TableProps<T extends object> {
  columns: Column<T>[];
  data: Array<any>;
  onHeaderClick: onHeaderClickFunc;
  sortName: string;
  sortAsc: boolean;
  loading?: boolean;
  pagination?: boolean;
}

export function Table<T extends {}>({
  columns,
  data = [],
  loading = false,
  sortName,
  sortAsc,
  pagination = false,
  onHeaderClick,
}: TableProps<T>): React.ReactElement {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,

    // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page
    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex }
  } = useTable<T>(
    {
      columns,
      data,
      initialState: { pageSize: 20 }
    },
    useSticky,
    useSortBy,
    usePagination
  );
  return (
    <>
      <div className={cx("order_table_info")}>
        <BTable striped bordered hover size="sm" className="order_table_info" style={{marginBottom:"0"}} variant="light"{...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} >
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}  className={column.id === "action" ? cx("tableHeaderCustom","whiteBorder"):cx("tableHeaderCustom")} style={
                    column.id === "action" ? {
                      position: "sticky",
                      zIndex: "3",
                      left: "0px",
                      border: "0",
                      borderRight:"0.5px solid #fff"
                    } : column.id === "stock_name" ? {
                      position: "sticky",
                      zIndex: "3",
                      left: "94.9px",
                      border: "0"
                    } : {}
                  } onClick={() => { column.id !== "action" && onHeaderClick(column.id, sortAsc) } }>
                    <div className={cx("tableHeaderWarp")} >
                      {column.render("Header")}
                      <div className={cx("arrow-group")} >
                        <div className={cx("up-arrow", column.id === sortName && sortAsc ? "up-arrow-action" : "", column.id === "action" && "hide")} />
                        <div className={cx("down-arrow", column.id === sortName && !sortAsc ? "down-arrow-action" : "", column.id === "action" && "hide")} />
                      </div>
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()} key="tbody">
            {!loading && page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} className={cx("tablebodyCustom")} >
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}  style={
                        cell.column.id === "action" ? {
                          position: "sticky",
                          zIndex: "3",
                          left: "0px",
                          border: "0"
                        } : cell.column.id === "stock_name" ? {
                          position: "sticky",
                          zIndex: "3",
                          left: "94.9px",
                          border: "0"
                        } : {}
                      } onClick={() => { }} key={cell.column.id}>
                        <BottomBlinker
                          key={cell.column.id}
                          className={cx('')}
                          compareValue={cell.value} >
                          {cell.render("Cell")}
                        </BottomBlinker></td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </BTable >
      </div>
      {loading && <div className={cx("paginatioWrap")}><Spinner animation="border" /> </div>}
      {!loading && page.length === 0 && <div className={cx("paginatioWrap", "text-secondary")}>尚無資料</div>}


    </>

  );
}